import React, { Fragment, useState } from "react";
import { Icon, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { canAdminComment } from "app/permissions";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import { CommentCheers } from "components/common/Cheers";

import CommentForm from "./CommentForm";
import CommentBody from "./CommentBody";
import CommentQuickLinks from "./CommentQuickLinks";

const InlineDot = () => (
  <span className="dot">
    <Icon icon="record" />
  </span>
);

const CommentView = ({ canDelete, comment, hideLinks, onDelete, onReplyClick, onCheerToggle }) => (
  <>
    <CommentQuickLinks comment={comment} canDelete={canDelete} onDelete={onDelete} />
    <CommentBody comment={comment} hideLinks={hideLinks} />
    <div className="comment-options">
      <CommentCheers comment={comment} onCheerToggle={onCheerToggle} />
      <InlineDot />
      <PlainButton className="reply-link no-select" onClick={onReplyClick}>
        <Trans>Reply</Trans>
      </PlainButton>
      <InlineDot />
      <span className="date no-select">
        <TimeDiff time={comment.createdAt} format="%b %e, %Y, %l:%M %p" />
      </span>
    </div>
  </>
);

const Comment = ({ comment, onCheerToggle, onDelete, onSubmit, hideLinks }) => {
  const { profile } = useProfile();
  const [replyingTo, onReplyClick] = useState(null);

  const onSubmitComment = ({ body }) => {
    onReplyClick(null);
    onSubmit({ parentCommentId: comment.id, body });
  };

  return (
    <div className="CommentListItem">
      <div className="CommentListItem__column">
        <CommentView
          canDelete={canAdminComment(profile, comment)}
          comment={comment}
          hideLinks={hideLinks}
          onDelete={onDelete}
          onReplyClick={() => onReplyClick(comment.id)}
          onCheerToggle={onCheerToggle}
        />
      </div>
      {replyingTo === comment.id && (
        <CommentForm onSubmit={onSubmitComment} />
      )}
      {comment.childComments?.map(childComment => (
        <Fragment key={childComment.id}>
          <div className="CommentListItem__column comment-child">
            <div className="reply">
              <Icon icon="reply" />
            </div>
            <CommentView
              canDelete={canAdminComment(profile, childComment)}
              comment={childComment}
              hideLinks={hideLinks}
              onDelete={onDelete}
              onReplyClick={() => onReplyClick(childComment.id)}
              onCheerToggle={onCheerToggle}
            />
          </div>
          {replyingTo === childComment.id && (
            <CommentForm onSubmit={onSubmitComment} />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default Comment;
